import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import App from './App/App';

// note - check if 'ROOT' wrap is really needed
const Root = () => (
  <Router>
    <App />
  </Router>
);

export default Root;



// WEBPACK FOOTER //
// ./src/components/Root.js